/* eslint-disable no-plusplus */
import moment from 'moment';
import { uncheckedMark, checkMark } from '../../../../SharedModules/pdfExport/DocDefinition';

const blueColorWithSelectedIcon = `<svg id="Checkbox-selected" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<rect id="Rectangle_2336" data-name="Rectangle 2336" width="20" height="20" rx="6" fill="#347dc6"/>
<path id="Path_18" data-name="Path 18" d="M4.4,7.3,0,2.908l1.42-1.42L4.4,4.4,8.792,0l1.42,1.42Z" transform="translate(4.734 6.763)" fill="#fff"/>
</svg>`;

const deselectedIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<g id="Checkbox" fill="#fff" stroke="#aaafb9" stroke-width="1">
  <rect width="20" height="20" rx="6" stroke="none"/>
  <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="none"/>
</g>
</svg>`;


const formatCurrency = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const cleaned = String(val).replace(/[^0-9.-]/g, '');
  const num = Number(cleaned);
  if (isNaN(num)) return String(val);
  return num < 0 ? `(${Math.abs(num).toFixed(2)})` : `$${num.toFixed(2)}`;
};

const formatUnits = (val, decimals = 4) => {
  if (val === null || val === undefined || val === '') return '';
  const num = Number(String(val).replace(/,/g, ''));
  if (isNaN(num)) return String(val);
  return num.toFixed(decimals);
};

const buildAdjustedClaimsDocDefinition = ({ infoObj = {}, unitParams, adjParams, selectionParts = [], fileName, selectedCriteria = {}, logInUser = {} }) => {
  const content = [];

  if (unitParams && unitParams.columnApi && unitParams.api) {
    const unitCols = unitParams.columnApi.getAllDisplayedColumns().filter((c) => !c.getColDef().pdfExportOptions?.skipColumn);
    const headers = unitCols.map((c) => c.getColDef().headerName || c.getColDef().field || '');
    const firstRow = unitParams.api.getDisplayedRowAtIndex(0);
    const dataRow = unitCols.map((c) => {
      const def = c.getColDef();
      const field = def.field || def.colId;
      let v = firstRow && firstRow.data ? firstRow.data[field] : '';
      if (def?.isAmount || (def.printPrefixValue && def.printPrefixValue.includes('$'))) v = formatCurrency(v);
      if (def?.exportZeroesFour) v = formatUnits(v, 4);
      if (/cms unit factor|billed unit factor/i.test(def.headerName || '')) {
        const n = Number(String(v).replace(/[^0-9.-]/g, '')) || 0;
        v = n.toFixed(4);
      }
      return v == null ? '' : String(v);
    });

    content.push({ text: 'Unit Conversion', style: 'tableCell', alignment: 'center', margin: [0, 2, 0, 2], bold: false });
    content.push({
      table: {
        headerRows: 1,
        widths: unitCols.map(() => '*'),
        body: [headers, dataRow],
      },
      // layout: 'noBorders',
      margin: [0, 6, 0, 12],
    });
  }

  if (adjParams && adjParams.columnApi && adjParams.api) {
    const rawCols = adjParams.columnApi.getAllDisplayedColumns();
    const adjCols = rawCols
      .map((c) => c.getColDef())
      .flatMap((c) => (c.children ? c.children : [c]))
      .filter((c) => !c.pdfExportOptions?.skipColumn)
      .filter((c) => (c.headerName || c.field) && !(c.field === 'ccCommentsExist' || (c.headerName && c.headerName.toLowerCase().includes('comments'))));

    const widths = adjCols.map((c) => {
      const h = (c.headerName || '').toLowerCase();
      if (/submitted|allowed|reimbursement|amount|factor|units/i.test(h)) return 80;
      if (/claim id|claim number|prescription|provider|ndc|drug name/i.test(h)) return 120;
      return '*';
    });

  const headers = adjCols.map((c) => {
    const headerText = c.headerName || c.field || '';
    const lower = (headerText || '').toLowerCase();
    const cell = { text: headerText, style: 'tableHeader', alignment: 'left', decoration: null };
    if (lower.includes('cms unit type') || lower.includes('billed unit factor')) {
      cell.alignment = 'center';
      cell.decoration = null;
    }
    return cell;
  });

    const body = [headers];

    // totals
    let totalSubmitted = 0;
    let totalAllowed = 0;
    let totalReimb = 0;
    let totalOrigUnits = 0;
    let totalNumUnits = 0;
    let totalBilledUnits = 0;

    adjParams.api.forEachNodeAfterFilterAndSort((node) => {
      const row = adjCols.map((c) => {
        const def = c;
        const field = def.field || def.colId;
        let v = node.data ? node.data[field] : '';
        if (def.isAmount || (def.printPrefixValue && def.printPrefixValue.includes('$')) || /submitted|allowed|reimbursement/i.test(def.headerName || '')) {
          const n = Number(String(v).replace(/[^0-9.-]/g, '')) || 0;
          if (/submitted/i.test(def.headerName || '')) totalSubmitted += n;
          if (/allowed/i.test(def.headerName || '')) totalAllowed += n;
          if (/reimbursement/i.test(def.headerName || '')) totalReimb += n;
          v = n < 0 ? `(${Math.abs(n).toFixed(2)})` : `$${n.toFixed(2)}`;
        }
        // units
        if (def.exportZeroesFour || /units/i.test(def.headerName || '') || /cms unit factor|billed unit factor/i.test(def.headerName || '')) {
          const n = Number(String(v).replace(/[^0-9.-]/g, '')) || 0;
          if (/orig/i.test(field) || /orig/i.test(def.headerName || '')) totalOrigUnits += n;
          if (/number of units/i.test(def.headerName || '')) totalNumUnits += n;
          if (/billed units/i.test(def.headerName || '')) totalBilledUnits += n;
          v = n.toFixed(4);
        }
        if (def.showCheckboxIcon || /(invoiced|reversed|dispute)/i.test(def.headerName || '')) {
          const checked = (v === 1 || v === '1' || v === true || v === 'true');
          v = {
            alignment: 'center',
            svg: checked ? blueColorWithSelectedIcon : deselectedIcon,
            width: 14,
            height: 14,
            marginTop: -1,
          };
          return v;
        }
        return typeof v === 'object' ? v : String(v);
      });
      body.push(row);
    });

    const totalRow = adjCols.map((c) => '');
    if (totalRow.length > 0) totalRow[0] = `Grand Total: ${adjParams.api.getDisplayedRowCount()} claims`;
    adjCols.forEach((c, idx) => {
      const h = (c.headerName || '').toLowerCase();
      if (h.includes('orig') && totalOrigUnits) totalRow[idx] = totalOrigUnits.toFixed(4);
      if (h.includes('number of units') && totalNumUnits) totalRow[idx] = totalNumUnits.toFixed(4);
      if (h.includes('billed units') && totalBilledUnits) totalRow[idx] = totalBilledUnits.toFixed(4);
      if ((h.includes('cms unit factor') || h.includes('billed unit factor')) && totalRow[idx] === '') totalRow[idx] = '0.0000';
      if (h.includes('submitted') && totalSubmitted) totalRow[idx] = totalSubmitted < 0 ? `(${Math.abs(totalSubmitted).toFixed(2)})` : `$${totalSubmitted.toFixed(2)}`;
      if (h.includes('allowed') && totalAllowed) totalRow[idx] = `$${totalAllowed.toFixed(2)}`;
      if (h.includes('reimbursement') && totalReimb) totalRow[idx] = `$${totalReimb.toFixed(2)}`;
    });
    const styledTotalRow = totalRow.map((cellVal) => {
      if (cellVal === '' || cellVal === null || cellVal === undefined) return '';
      return { text: String(cellVal), bold: true, fontSize: 10, fillColor: '#fff' };
    });
    body.push(styledTotalRow);

    const PDF_HEADER_COLOR = '#f8f8f8';
    const PDF_INNER_BORDER_COLOR = '#dde2eb';
    const PDF_OUTER_BORDER_COLOR = '#babfc7';
    const PDF_ODD_BKG_COLOR = '#fcfcfc';
    const PDF_EVEN_BKG_COLOR = '#fff';
    const PDF_HEADER_HEIGHT = 20;
    const PDF_ROW_HEIGHT = 0;

  const heights = (rowIndex) => (rowIndex < 1 ? PDF_HEADER_HEIGHT : PDF_ROW_HEIGHT);
  const fillColor = (rowIndex, node) => (rowIndex < node.table.headerRows ? PDF_HEADER_COLOR : rowIndex % 2 === 0 ? PDF_ODD_BKG_COLOR : PDF_EVEN_BKG_COLOR);
  
  const hLineWidth = (i, node) => (i === 0 || i === node.table.body.length ? 1.4 : 1);
  const vLineWidth = (i, node) => (i === 0 || i === node.table.widths.length ? 1.4 : 1);
  const hLineColor = (i, node) => (i === 0 || i === node.table.body.length ? PDF_OUTER_BORDER_COLOR : PDF_INNER_BORDER_COLOR);
  const vLineColor = (i, node) => (i === 0 || i === node.table.widths.length ? PDF_OUTER_BORDER_COLOR : PDF_INNER_BORDER_COLOR);

    content.push({
      style: 'myTable',
      table: { headerRows: 1, widths, body, heights },
    //   layout: { fillColor, hLineWidth, vLineWidth, hLineColor, vLineColor },
    });
  }

  if (selectedCriteria && Object.keys(selectedCriteria).length > 0) {
    content.push({ text: '\n' });
    content.push({
      alignment: 'center',
      fontSize: 9,
      margin: [28.8, 10, 28.8, 20],
      style: 'tableExample',
      table: {
        widths: ['*','*', '*', '*', '*', '*', '*'],
        body: [
          [
            {
              text: [{ text: 'Search Criteria: ', bold: true }, ''],
              fontSize: 9,
              fontFamily: 'arial',
              alignment: 'center',
            },
            {
              text: [{ text: 'Invoiced: ' }, selectedCriteria?.invoiced || 'N/A'],
              fontSize: 9,
              fontFamily: 'arial',
              alignment: 'center',
            },
            {
              text: [{ text: 'Not Invoiced: ' }, selectedCriteria?.notInvoiced || 'N/A'],
              fontSize: 9,
              fontFamily: 'arial',
              alignment: 'center',
            },
            {
              text: [{ text: 'Billed Units: ' }, selectedCriteria?.billedUnits || 'N/A'],
              fontSize: 9,
              fontFamily: 'arial',
              alignment: 'center',
            },
            {
              text: [{ text: 'Not Billed Units: ' }, selectedCriteria?.notBilledUnits || 'N/A'],
              fontSize: 9,
              fontFamily: 'arial',
              alignment: 'center',
            },
            {
              text: [{ text: 'For Dispute Resolution: ' }, selectedCriteria?.forDisputeResolution || 'N/A'],
              fontSize: 9,
              fontFamily: 'arial',
              alignment: 'center',
            },
            {
              text: [{ text: 'Not For Dispute Resolution: ' }, selectedCriteria?.notForDisputeResolution || 'N/A'],
              fontSize: 9,
              fontFamily: 'arial',
              alignment: 'center',
            },
          ],
        ],
      },
      layout: 'noBorders',
    });
  }

  const {
    firstInfo = '',
    secondInfo = '',
    thirdInfo = '',
    fourthInfo = '',
    fifthInfo = '',
  } = infoObj;

  let topHeaderMargin = 80;
  if (firstInfo.length >= 25 || secondInfo.length >= 25 || thirdInfo.length >= 25) topHeaderMargin = 90;
  if (fourthInfo.length || fifthInfo.length) topHeaderMargin = 120;

  const pageMargins = [28.8, topHeaderMargin, 28.8, 25.92];
// let widths = [109, 109, 109, 109, 109, 109, 109];
        // if (isScrollOn) {
        //   const columnsToExport1 = getColumnsToExport();
        //   const pageWidth = columnsToExport1.length * defaultColWidth - 75;
        //   widths = [
        //     pageWidth / 7.1,
        //     pageWidth / 7.1,
        //     pageWidth / 7.1,
        //     pageWidth / 7.1,
        //     pageWidth / 7.1,
        //     pageWidth / 7.1,
        //     pageWidth / 7.1,
        //   ];
        // }
  const header = (currentPage, pageCount) => ({
    alignment: 'center',
    fontSize: 10,
    margin: [28.8, 4, 28.8, 25.92],
    style: 'tableExample',
    table: {
      headerRows: 1,
      widths:['*','*','*'],
      body: [
        [
          { text: `Requested By: ${logInUser || ''}`, fontSize: 10, alignment: 'left' },
          { text: 'Adjusted Claims Report', fontSize: 12, bold: true, alignment: 'center' },
          { text: `Date Printed: ${moment(new Date()).format('MM/DD/YYYY')}`, fontSize: 10, alignment: 'right' },
        ],
        [
          { text: firstInfo, fontSize: 10, alignment: 'left' },
          { text: thirdInfo, fontSize: 10, alignment: 'center', bold: true },
          { text: `Total Records: ${adjParams.api.getDisplayedRowCount()}`, fontSize: 10, alignment: 'right' },
        ],
        [
          { text: secondInfo, fontSize: 10, alignment: 'left' },
          { text: fourthInfo, fontSize: 10, alignment: 'center' },
          { text: `Page: ${currentPage} of ${pageCount}`, fontSize: 10, alignment: 'right' },
        ],
      ],
    },
    layout: 'noBorders',
  });

  const footer = (currentPage, pageCount) => {
    const currentYear = new Date().getFullYear();
    const items = [];
    items.push({
      text: `${currentYear} Conduent Business Services, LLC. All rights reserved. Conduent and Conduent Agile Star are trademarks of Conduent Business Services, LLC in the United States and/or other countries.`,
      fontSize: 8,
      color: '#636363',
      alignment: 'center',
    });
    return items;
  };

  const docDefinition = {
    pageOrientation: 'landscape',
    header,
    footer,
    pageMargins,
    content,
    styles: {
      title: { fontSize: 14, bold: true, alignment: 'center' },
      subTitle: { fontSize: 11, bold: true, margin: [0, 6, 0, 6] },
  tableHeader: { bold: true, fontSize: 9 },
  tableCell: { fontSize: 9, margin: [2, 4, 2, 4] },
      selection: { fontSize: 9, margin: [0, 6, 0, 0] },
    },
    defaultStyle: { fontSize: 9 },
  };

  try {
    const defaultColWidth = 100;
    if (adjParams && adjParams.columnApi) {
      const displayed = adjParams.columnApi.getAllDisplayedColumns().filter((c)=>{
        const d = c.getColDef();
        if (!d) return true;
        if (d.pdfExportOptions && d.pdfExportOptions.skipColumn) return false;
        if (d.field === 'ccCommentsExist') return false;
        if (d.headerName && d.headerName.toLowerCase().includes('comments')) return false;
        return true;
      });
      if (displayed && displayed.length > 7) {
        docDefinition.pageSize = { height: 700, width: displayed.length * defaultColWidth };
      }
    }
  } catch (e) {
    // ignore
  }

  return docDefinition;
};

export default buildAdjustedClaimsDocDefinition;
